import parkingMapUrl from './karte_mapa.png';

// Keš na nivou modula — mapa je ~1.5MB, ne treba je učitavati više puta
let cachedDataUrl = null;

/**
 * Učitaj parking mapu kao base64 data URL za upotrebu u jsPDF.addImage().
 *
 * jsPDF addImage zahteva sinhroni pristup pikselima — webpack import PNG-a
 * vraća URL string koji jsPDF ne može da fetch-uje sam. Zato ručno fetch-ujemo,
 * pretvaramo u base64 i keširamo rezultat za naredne pozive u istoj sesiji.
 */
export const getParkingMapDataUrl = async () => {
  if (cachedDataUrl) return cachedDataUrl;

  const response = await fetch(parkingMapUrl);
  const blob = await response.blob();

  cachedDataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  return cachedDataUrl;
};
